import * as React from 'react';

import {FacebookColoredIcon} from 'shells/icon/facebook-colored-icon';
import {IntegrationWidget} from 'shells/integration-widget/integration-widget';
import type {IntegrationWidgetStatus} from 'shells/integration-widget/integration-widget';

import type {GetFacebookIntegration_facebookIntegration as FacebookIntegration} from 'nutshell-graphql-types';

import {getIntegrationWidgetStatusEnum} from '../../inbound/helpers';

import {
    useToggleFacebookInstagramIsEnabled,
    useDeleteAllFacebookInstagramData,
} from '../graphql/hooks';

import {IntegratedPagesList} from './integrated-pages-list';
import {SettingsWrapper} from './settings-wrapper';

type Props = {
    facebookIntegration: FacebookIntegration;
    isLoadingFacebookIntegration: boolean;
    refetchFacebookIntegration: () => Promise<any>;
};

export function SettingsIntegrationComplete(props: Props) {
    const [integrationWidgetStatus, setIntegrationWidgetStatus] =
        React.useState<IntegrationWidgetStatus>(
            getIntegrationWidgetStatusEnum(props.facebookIntegration.isEnabled, false)
        );
    const [isToggling, setIsToggling] = React.useState(false);

    const {toggleFacebookInstagramIsEnabled} = useToggleFacebookInstagramIsEnabled();

    const {deleteAllFacebookInstagramData} = useDeleteAllFacebookInstagramData();

    React.useEffect(() => {
        setIntegrationWidgetStatus(
            getIntegrationWidgetStatusEnum(
                props.facebookIntegration.isEnabled,
                props.isLoadingFacebookIntegration && isToggling
            )
        );
    }, [props.facebookIntegration.isEnabled, props.isLoadingFacebookIntegration, isToggling]);

    const onToggleClick = () => {
        setIsToggling(true);
        toggleFacebookInstagramIsEnabled()
            .then(() => props.refetchFacebookIntegration())
            .then(() => setIsToggling(false));
    };

    const onRevokeClick = () => {
        deleteAllFacebookInstagramData().then(() => props.refetchFacebookIntegration());
    };

    return (
        <>
            <IntegrationWidget
                account={props.facebookIntegration.userEmail}
                // @ts-expect-error
                logo={<FacebookColoredIcon size={24} alignCenter={true} wrapWithDiv={false} />}
                status={integrationWidgetStatus}
                onConnectClick={onToggleClick}
                onDisconnectClick={onToggleClick}
                onRevokeClick={onRevokeClick}
                revokeWarning='Are you sure you want to forget this account? This action will remove all Messenger and Instagram threads from your inbox, and cannot be undone.'
            />
            <IntegratedPagesList pages={props.facebookIntegration.pages} />
            <SettingsWrapper />
        </>
    );
}
